export class ProdutoImpostoPreCadastroFormModel {
  constructor(
    public codigoNcm: string = "",
    public ncmId: string | null = null,
    public imposto: string = "",
    public impostoId: string | null = null,
  ) { }
}
